import HorizontalMenu from "../components/horizontalMenu";
import React, { isValidElement, useEffect, useState } from 'react';
import { Container, Row, Col, Nav, Tab, Button } from 'react-bootstrap';
import { useParams } from "react-router";
import axiosInstance from '../utils/axiosInstance';
import { useNavigate } from "react-router-dom";
import { FaTrophy } from 'react-icons/fa';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import ClipLoader from "react-spinners/ClipLoader"
import SavedTemplatesList from "../components/Templates/SavedTemplatesList";


const Profile = () => {
  const [profileData, setProfileData] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState("");
  const navigate = useNavigate();
  const { username } = useParams();
  const [savedTemplates, setSavedTemplates] = useState([]);

  useEffect(() => {
    axiosInstance.get(`/users/templatesSaved/${username}`)
    .then(response => setSavedTemplates(response.data))
  }, [])

  useEffect(() => {
    const params = {
        username: username
    }
    axiosInstance.get("/users/user",  { params })
    .then(response => { 
      setProfileData(response.data);
      setLoading(false);
    })
    .catch(error => navigate('/home'))


    axiosInstance.get('/users/current')
    .then(response => setCurrentUser(response.data.username))
    .catch()
  }, [username]);

  const onEditClick = () => { navigate('/user/edit', {state: {profileName: profileData.displayName, userLocation: profileData.location}})}
  const onUnsave = (id) => { 
    axiosInstance.delete(`/users/templatesSaved/${id}`);
    setSavedTemplates(savedTemplates.filter(template => template.id !== id)) 
  }

  return (
    <div>
    <HorizontalMenu />
    <Container className="mt-4">
      <h1 className="mb-4">Profile {username == currentUser ? <Button onClick={onEditClick}>Edit</Button>: ""} </h1> 
      <ClipLoader loading={isLoading}/>
      <div style={{ display: !isLoading ? 'block': 'none'}}>
      <Row>
        <Col>
          <h4>{profileData.displayName}</h4>
          <p><strong>{profileData.totalDaysCompleted || 0}</strong> Activites Completed • <strong>{profileData.createdCount || 0}</strong> {profileData.createdCount === 1 ? "Challenge Created" : "Challenges Created"}</p>
          <br></br>
          <p><strong>Username:</strong> <span style={{ color: '#888' }}>{profileData.username}</span></p>
          <p><strong>Joined:</strong> <span style={{ color: '#888' }}>{profileData.joinDate}</span></p>
          <p><strong>Location:</strong> <span style={{ color: '#888' }}>{profileData.location}</span></p>

        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Tab.Container defaultActiveKey="trophies">
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link eventKey="trophies">Trophies</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="challengesCompleted">Challenges Completed</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="savedTemplates">Saved Templates</Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
            <Tab.Pane eventKey="trophies">
                {profileData && profileData.trophies && ( // Conditionally render if profileData.trophies exists
                  <>
                    <h3>Trophies</h3>
                    <ul style={{ paddingLeft: 0}}>
                      {profileData.trophies.map((trophy, index) => (
                        <li key={index} style={{ listStyleType: "none"}}><FaTrophy style={{ color: "gold"}}/> {trophy}</li>
                      ))}
                    </ul>
                  </>
                )}
              </Tab.Pane>
              <Tab.Pane eventKey="challengesCompleted">
                <h3>Challenges Completed</h3>
      
                <p>Total: {profileData && profileData.challengesCompleted && profileData.challengesCompleted.length || 0}</p>
                <ul style={{ paddingLeft: 0}}>
                  {profileData && profileData.challengesCompleted && profileData.challengesCompleted.map((challenge, index) => (
                          <li key={index} style={{ listStyleType: "none"}}> <AiOutlineCheckCircle /> {challenge}</li>
                        ))}
                </ul>
              </Tab.Pane>
              <Tab.Pane eventKey="savedTemplates">
                <h3>Saved Challenge Templates</h3>
                <SavedTemplatesList isOwner={username == currentUser} templates={savedTemplates} onUnsave={onUnsave}/>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Col>
      </Row>
      </div>
    </Container>
    </div>
  );
};

export default Profile;

